import { Typography } from '@mui/material';
import { GeoJSONFeature } from 'ol/format/GeoJSON';
import { Fragment, useState } from 'react';
import {
    DeviceDetailProperties,
    ParameterRow,
    StatusSeverity,
} from '../../models/models';
import {
    FlexBoxFullWHColumn,
    FlexBoxFullWRowBetween,
} from '../layout/layout.styles';
import ChartsButton from '../ui/charts-button/charts-button.component';
import DeviceTable from './device-table/device-table.component';
import ParamsCHartsList from './params-charts-list/params-charts-list.component';

const DeviceBlock = ({
    device,
    showCharts,
    onChartsVisibilityChange,
    onDeviceStatusSeverityChange,
}: {
    device: GeoJSONFeature;
    showCharts: boolean;
    onChartsVisibilityChange: () => void;
    onDeviceStatusSeverityChange: (status: StatusSeverity) => void;
}) => {
    const [rowsSelected, setRowsSelected] = useState<ParameterRow[]>([]);

    const onRowSelected = (row: ParameterRow) => {
        if (rowsSelected.map((r) => r.id).includes(row.id)) {
            setRowsSelected((prev) => prev.filter((r) => r.id !== row.id));
        } else {
            setRowsSelected((prev) => [...prev, row]);
        }
    };

    return (
        <FlexBoxFullWHColumn>
            <Fragment>
                {showCharts ? (
                    <ParamsCHartsList
                        deviceId={device.id}
                        deviceName={
                            (device.properties as DeviceDetailProperties).name
                        }
                        params={rowsSelected}
                    />
                ) : (
                    <DeviceTable
                        device={device}
                        rowsSelected={rowsSelected.map((r) => r.id)}
                        onRowSelected={onRowSelected}
                        onDeviceStatusSeverityChange={
                            onDeviceStatusSeverityChange
                        }
                    />
                )}
                <FlexBoxFullWRowBetween alignItems={'center'} pt={2}>
                    <Typography>
                        {rowsSelected.length} parametri selezionati
                    </Typography>
                    <ChartsButton
                        active={!showCharts}
                        disabled={rowsSelected.length === 0}
                        onClick={onChartsVisibilityChange}
                    />
                </FlexBoxFullWRowBetween>
            </Fragment>
        </FlexBoxFullWHColumn>
    );
};

export default DeviceBlock;
